import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminTransactionsComponent } from './admin-transactions/admin-transactions.component';
import { AdminValidationsComponent } from './admin-validations/admin-validations.component';
import { AdminCommunicationsComponent } from './admin-communications/admin-communications.component';

import { AdminComponent } from './admin.component';

import { AdminRoutingModule } from './admin.routing';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminCarsComponent } from './admin-cars/admin-cars.component';
import { AdminContractsComponent } from './admin-contracts/admin-contracts.component';
import { AdminRentComponent } from './admin-rent/admin-rent.component';
import { AdminCarRefsComponent } from './admin-carrefs/admin-carrefs.component';
import { AdminBuyComponent } from './admin-buy/admin-buy.component';
import { AdminKeepComponent } from './admin-keep/admin-keep.component';
import { AdminAppointmentsComponent } from './admin-appointments/admin-appointments.component';
import { DealerModule } from '../dealer/dealer.module';

import { CarrefManufacturersComponent } from './admin-carrefs/carref-manufacturers/carref-manufacturers.component';
import { CarrefEnginesComponent } from './admin-carrefs/carref-engines/carref-engines.component';
import { CarrefMakesComponent } from './admin-carrefs/carref-makes/carref-makes.component';
import { CarrefModelsComponent } from './admin-carrefs/carref-models/carref-models.component';
import { CarrefVersionsComponent } from './admin-carrefs/carref-versions/carref-versions.component';
import { CarrefFeaturesComponent } from './admin-carrefs/carref-features/carref-features.component';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { CarrefJobTasksComponent } from './admin-carrefs/carref-job-tasks/carref-job-tasks.component';
import { CarrefJobTemplatesComponent } from './admin-carrefs/carref-job-templates/carref-job-templates.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DynamicTableComponent } from 'src/app/public/common/generic/dynamic-table/dynamic-table.component';
import { CarCardAccountComponent } from 'src/app/public/car/elements/car-card-account/car-card-account.component';
import { BookingsComponent } from 'src/app/public/rent/elements/bookings/bookings.component';
import { ContractsComponent } from 'src/app/public/account/elements/contracts/contracts.component';
import { CarSearchComponent } from 'src/app/public/car/elements/car-cards/car-search.component';
import { AppointmentsComponent } from 'src/app/public/common/elements/appointments/appointments.component';

@NgModule({
  declarations: [
    AdminComponent,
    AdminDashboardComponent,

    AdminUsersComponent,
    AdminContractsComponent,

    AdminCarsComponent,
    AdminCarRefsComponent,

    AdminBuyComponent,
    AdminRentComponent,
    AdminKeepComponent,

    AdminAppointmentsComponent,

    AdminTransactionsComponent,
    AdminValidationsComponent,
    AdminCommunicationsComponent,

    CarrefManufacturersComponent,
    CarrefEnginesComponent,
    CarrefMakesComponent,
    CarrefModelsComponent,
    CarrefVersionsComponent,
    CarrefFeaturesComponent,

    CarrefJobTemplatesComponent,
    CarrefJobTasksComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    AdminRoutingModule,

    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    
    DealerModule,

    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    MatSidenavModule,
    MatProgressSpinnerModule,

    DynamicTableComponent,
    CarCardAccountComponent,
    BookingsComponent,
    ContractsComponent,
    CarSearchComponent,
    AppointmentsComponent

//import { MatTableDataSource, MatTableModule } from '@angular/material/table';
//import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
//import { MatSort, MatSortModule } from '@angular/material/sort';
  ]
})
export class AdminModule { }
